module.exports = __webpack_public_path__ + "static/Conversational-Bots-dba0b1dad2d2f075f60d5f62b218a110.jpg";